import React from 'react';
import styles from "../../../styles";

const TextSpan = (({text, handleTextClick, ratio, index, outline}) => (
  <span
    key={`text_${index}`}
    style={{
      ...styles.text.textValue,
      fontFamily: text.fontFamily,
      fontSize: `${text.fontSize * ratio}px`,
      color: text.colour,
      minHeight: 0,
      transform: `translate(-50% , -50%) translate(${text.x * ratio}px, ${text.y * ratio}px)`,
      boxShadow: outline && "0 0 0 1px #D5C17D",
      padding: outline && "10px",
      cursor: handleTextClick ? 'pointer' : 'auto'
    }}
    onClick={() => {
      if (handleTextClick) {
        handleTextClick(text);
      }
    }}
  >
          {text.value}
        </span>
));

export default TextSpan;


// WEBPACK FOOTER //
// ./src/components/areas/Preview/TextSpan.js